import { render, staticRenderFns } from "./SettingsTabFinancial.vue?vue&type=template&id=38012dc2"
import script from "./SettingsTabFinancial.vue?vue&type=script&lang=js"
export * from "./SettingsTabFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports